/**
 * @desc converts currency in decimal places to 2 decimal places
 * @param num: number
 * @param places: Optional, the decimal places you want to round to
 * @returns number
 */
export const roundToDecimals = (num: number, places = 2): number => {
  return +(Math.round((num + `e+${places}`) as unknown as number) + `e-${places}`)
}
